import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SmartSearchComponent } from "./smart.search/smart.search/smart.search.component";
import { CommonMaterialModule } from "@nrwl/common-material";
import { SuggestionsSearchProvider } from "./smart.search/suggestions.search.provider";
import { TagInputModule } from 'ngx-chips';
import { DemoSuggestionsSearchProvider } from "./smart.search/demo/demo.suggestions.search.provider";
import { SmartSearchTagInputDirective } from "./smart.search/basic.mode/tag.validation.directive";
import { BasicModeComponent } from "./smart.search/basic.mode/basic.mode.component";
import { ExpertModeComponent } from "./smart.search/expert.mode/expert.mode.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { QueryExpressionParserService } from "@nrwl/query-emitter";
import { DemoQueryExpressionParserService } from "./smart.search/demo/demo.query.expression.parser.service";
import { FreeFormFilterComponent } from "./smart.search/free.form.filter/free.form.filter.component";
import { ChipComponent } from "./smart.search/free.form.filter/chip/chip.component";
import { OperatorComponent } from "./smart.search/free.form.filter/operator/operator.component";
import { SubmitComponent } from "./smart.search/free.form.filter/submit/submit.component";
import { AutoSuggestComponent } from "./smart.search/free.form.filter/auto.suggest/auto.suggest.component";
import { CommonLibModule } from "@nrwl/common-lib";

@NgModule({
  imports: [CommonModule, CommonMaterialModule, TagInputModule, FormsModule, ReactiveFormsModule, CommonLibModule],
  declarations: [SmartSearchComponent, SmartSearchTagInputDirective, BasicModeComponent, ExpertModeComponent, 
    ChipComponent, OperatorComponent, SubmitComponent, AutoSuggestComponent, FreeFormFilterComponent],
  providers: [
    { provide: SuggestionsSearchProvider, useClass: DemoSuggestionsSearchProvider },
    { provide: QueryExpressionParserService, useClass: DemoQueryExpressionParserService}
  ],
  exports: [SmartSearchComponent, SubmitComponent, ChipComponent, OperatorComponent]
})
export class SmartSearchModule {}
